export default function ProfilePage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Profile</h1>
      <p className="text-muted-foreground">User profile management will be displayed here.</p>
    </div>
  );
}
